<template>
  <nav class="px-[10px] hc-flex hc-flex-grow hc-flex-col z-50">
    <ul class="hc-flex hc-flex-col z-50">
      <slot></slot>
    </ul>
  </nav>
</template>
